/* ─────────────────────────────────────────────────────────────
   Cartridge Works — app.js
   Vanilla, precompiled, no runtime dependencies.
   Everything works without JS; this file adds the moving parts.
   ───────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  /* Counted from the page, not hardcoded: index.html runs seven
     channels, index-v2.html runs eight. */
  /* Descendant, not child. Shopify wraps every section it renders in a
     <div id="shopify-section-…">, so the ch-N divs are grandchildren of
     .stage here, not children. The old child combinator matched nothing
     and fell through to the || 7 default — which would have quietly
     dropped channel 8, Contact, off the nav. */
  var CHANNEL_COUNT = document.querySelectorAll('.stage div[id^="ch-"]').length || 7;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── navigation ─────────────────────────────────────────── */

  function goto(n) {
    if (n < 1 || n > CHANNEL_COUNT) return;
    setActiveRail(n);
    var el = document.getElementById("ch-" + n);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? "auto" : "smooth" });
  }

  var railBtns = Array.prototype.slice.call(document.querySelectorAll(".rail-btn"));
  function setActiveRail(n) {
    railBtns.forEach(function (b, i) {
      b.classList.toggle("active", i + 1 === n);
    });
  }

  // every [data-goto] element jumps to a channel
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-goto]");
    if (!t) return;
    goto(parseInt(t.getAttribute("data-goto"), 10));
  });

  // keyboard: 1–7 switches channel (ignored while typing)
  window.addEventListener("keydown", function (e) {
    if (e.target.matches("input, textarea, select")) return;
    if (/^[1-9]$/.test(e.key)) goto(parseInt(e.key, 10));   // goto() clamps to what exists
  });

  /* ── scrollspy ──────────────────────────────────────────── */

  var spy = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var n = parseInt(en.target.id.replace("ch-", ""), 10);
      if (n) setActiveRail(n);
    });
  }, { rootMargin: "-40% 0px -50% 0px", threshold: 0 });

  for (var i = 1; i <= CHANNEL_COUNT; i++) {
    var ch = document.getElementById("ch-" + i);
    if (ch) spy.observe(ch);
  }

  /* ── scroll reveal ──────────────────────────────────────── */

  var channels = Array.prototype.slice.call(document.querySelectorAll(".channel"));
  if (reduceMotion) {
    channels.forEach(function (el) { el.classList.add("in-view"); });
  } else {
    var rev = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("in-view");
          rev.unobserve(en.target);
        }
      });
    }, { threshold: 0.08 });
    channels.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in-view");
      else rev.observe(el);
    });
  }

  /* ── hero ───────────────────────────────────────────────── */

  var heroVideo = document.getElementById("hero-video");
  if (heroVideo) heroVideo.play().catch(function () {});

  var dotsEl = document.querySelector(".anim-dots");
  if (dotsEl && !reduceMotion) {
    var seq = [".", "..", "...", ".."], di = 2; // markup starts at "..."
    setInterval(function () {
      di = (di + 1) % seq.length;
      dotsEl.textContent = seq[di];
    }, 380);
  }

  // the logo loads in one of two colours
  var logo = document.getElementById("brand-logo");
  if (logo && Math.random() < 0.5) logo.src = "assets/greeny.png";

  /* ── cartridge shelf ────────────────────────────────────── */

  var carts = Array.prototype.slice.call(document.querySelectorAll(".cart"));
  var panels = Array.prototype.slice.call(document.querySelectorAll(".svc-panel"));

  carts.forEach(function (cart) {
    cart.addEventListener("click", function () {
      var id = cart.getAttribute("data-svc");
      carts.forEach(function (c) {
        var on = c === cart;
        c.classList.toggle("active", on);
        c.setAttribute("aria-pressed", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute("data-panel") !== id;
      });
      if (!reduceMotion) {
        cart.classList.add("inserting");
        setTimeout(function () { cart.classList.remove("inserting"); }, 360);
      }
    });
  });

  /* ── showreel ───────────────────────────────────────────── */

  var reel = document.getElementById("reel-video");
  var reelWrap = document.getElementById("reel-wrap");
  var playBtn = document.getElementById("reel-play");
  var muteBtn = document.getElementById("reel-mute");
  var fsBtn = document.getElementById("reel-fs");

  function reelToggle() {
    if (!reel) return;
    if (reel.paused) { reel.play(); playBtn.classList.add("hidden"); }
    else { reel.pause(); playBtn.classList.remove("hidden"); }
  }

  if (reel) {
    reel.addEventListener("click", reelToggle);
    reel.addEventListener("ended", function () { playBtn.classList.remove("hidden"); });
    playBtn.addEventListener("click", reelToggle);
    muteBtn.addEventListener("click", function () {
      reel.muted = !reel.muted;
      muteBtn.textContent = reel.muted ? "Unmute" : "Mute";
    });
    fsBtn.addEventListener("click", function () {
      if (!document.fullscreenElement) {
        if (reelWrap.requestFullscreen) reelWrap.requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    });
    // pause when scrolled out of view
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && !reel.paused) {
          reel.pause();
          playBtn.classList.remove("hidden");
        }
      });
    }, { threshold: 0.1 }).observe(reelWrap);
  }

  /* ── manifesto typing ───────────────────────────────────── */
  /* The manifesto is fully rendered in the HTML for crawlers and
     no-JS visitors. With JS and normal motion settings, we clear
     it and retype it when it scrolls into view. Reduced motion
     keeps the static version. */

  var MANIFESTO = [
    { t: "// manifesto.txt", cls: "term-comment", speed: 22, pause: 400 },
    { t: "", pause: 140 },
    { t: "> Don't work with dickheads.", cls: "term-strike", speed: 20, pause: 500 },
    { t: "", pause: 80 },
    { t: "> Work should feel human.", speed: 18, pause: 320 },
    { t: "", pause: 80 },
    { t: "> Leave the fingerprints in.", speed: 17, pause: 320 },
    { t: "", pause: 80 },
    { t: "> If it doesn't land, it doesn't ship.", speed: 15, pause: 320 },
    { t: "", pause: 80 },
    { t: "> Authenticity above all else.", cls: "term-closer", speed: 18, pause: 500 },
    { t: "", pause: 140 },
    { t: "[EOF]", cls: "term-comment", speed: 22 }
  ];

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  async function typeManifesto(body) {
    body.innerHTML = '<span class="term-cursor">_</span>';
    var cursor = body.querySelector(".term-cursor");
    for (var li = 0; li < MANIFESTO.length; li++) {
      var line = MANIFESTO[li];
      if (!line.t) {
        body.insertBefore(document.createElement("br"), cursor);
        await sleep(line.pause || 0);
        continue;
      }
      var span = document.createElement("span");
      span.className = line.cls || "";
      body.insertBefore(span, cursor);
      for (var ci = 0; ci < line.t.length; ci++) {
        span.textContent += line.t[ci];
        await sleep(line.speed || 30);
      }
      if (line.cls === "term-strike") {
        (function (s) { setTimeout(function () { s.classList.add("done"); }, 180); })(span);
      }
      body.insertBefore(document.createElement("br"), cursor);
      await sleep(line.pause || 0);
    }
    cursor.style.display = "none";
  }

  var terminalBody = document.getElementById("terminal-body");
  if (terminalBody && !reduceMotion) {
    /* Watch the terminal, not the section around it. The section
       is taller than the viewport, so a threshold against it fired
       while the terminal was still below the fold and the thing
       typed itself to nobody. */
    var whySection = terminalBody.closest(".terminal") || terminalBody;
    var typed = false;
    new IntersectionObserver(function (entries, io) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !typed) {
          typed = true;
          io.disconnect();
          typeManifesto(terminalBody);
        }
      });
    }, { threshold: 0.45 }).observe(whySection);
  }

  /* ── contact form ───────────────────────────────────────── */
  /* Without JS the form posts natively to Formspree. With JS we
     stay on the page and swap in the success state. */

  var form = document.getElementById("compose-form");
  if (form) {
    var bodyEl = document.getElementById("compose-body");
    var successEl = document.getElementById("compose-success");
    var errorEl = document.getElementById("compose-error");
    var submitBtn = document.getElementById("compose-submit");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending…";

      var data = new FormData(form);
      fetch(form.action, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" }
      }).then(function (res) {
        if (res.ok) {
          bodyEl.hidden = true;
          successEl.hidden = false;
        } else {
          throw new Error("send failed");
        }
      }).catch(function () {
        errorEl.textContent = "Didn't send. Give it another go, or email hello@cartridge.works directly.";
        errorEl.hidden = false;
      }).finally(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = "Send message ▸";
      });
    });
  }
})();
